import React from 'react';
import { useSelector } from 'react-redux';
import { usePrefs } from 'wsm-common-data';
import propTypes from 'prop-types';
import STLVideo from './STLVideo';
import NationalCharity from './NationalCharity';
import LocalCharity from './LocalCharity';
import Legal from './FooterInfo';
import CTAButtons from './CTAButtons';
import DonationLanguage from './DonationLanguage';

const STLContainer = ({ impact, emt, deviceType }) => {
	const getAttribute = {
		text: (attributeId) => {
			return emt.attributes[attributeId]?.attributeText ?? '';
		},
		path: (attributeId) => {
			return emt.attributes[attributeId]?.attributePath ?? '';
		}
	};

	const snowflakeContainerStyles = () => {
		return {
			background: `url("${getAttribute.path(
				deviceType === 'DESKTOP' ? 1 : 2
			)}") 0 0 transparent no-repeat`,
			backgroundSize: '100% auto',
			paddingTop: deviceType === 'DESKTOP' ? '125px' : '35px'
		};
	};
	const { partsFlag, donationLanguage } = impact.dealerCharity[0];

	const prefs = usePrefs();
	const {
		charitySubmissionUrl,
		impactAssetDomain,
		charityCodes,
		charitySubmissionSource
	} = prefs;
	const { dealerCode } = useSelector((state) => state.accountData);
	const videoLink = getAttribute.text(3);

	return (
		<div className="stl-container">
			<div
				className={`${deviceType.toLowerCase()}`}
				style={snowflakeContainerStyles()}
			>
				<DonationLanguage
					partsFlag={partsFlag}
					donationLanguage={donationLanguage}
					getAttribute={getAttribute}
				/>
				<CTAButtons
					charitySubmissionUrl={charitySubmissionUrl}
					dealerCode={dealerCode}
					charitySubmissionSource={charitySubmissionSource}
					additionalClasses="py-5 px-md-15 px-8"
				/>
				<LocalCharity
					impactBaseUrl={impactAssetDomain}
					deviceType={deviceType}
					getAttribute={getAttribute}
					impact={impact}
					id="htc"
				/>
			</div>
			<NationalCharity
				charitySubmissionUrl={charitySubmissionUrl}
				dealerCode={dealerCode}
				deviceType={deviceType}
				getAttribute={getAttribute}
				charityCodes={charityCodes.split(',')}
				charitySubmissionSource={charitySubmissionSource}
			/>
			{videoLink && (
				<STLVideo
					commercialVideoHeadline={getAttribute.text(96)}
					headerTitle=""
					headerCopy=""
					youtubeLink={videoLink}
					deviceType={deviceType}
				/>
			)}
			<CTAButtons
				charitySubmissionUrl={charitySubmissionUrl}
				dealerCode={dealerCode}
				charitySubmissionSource={charitySubmissionSource}
				id="charities"
				additionalClasses="py-5 px-md-15 px-8"
			/>
			<Legal />
		</div>
	);
};

STLContainer.propTypes = {
	impact: propTypes.shape({
		dealerCharity: propTypes.shape([])
	}).isRequired,
	emt: propTypes.shape({
		attributes: propTypes.shape({
			attributeText: propTypes.string,
			attributePath: propTypes.string
		})
	}).isRequired,
	deviceType: propTypes.string.isRequired
};

export default STLContainer;
